// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gW-2","title":"styles_title__1GyZZ"};